<template>
    <div>
        <h3 class="form-heading">AWS Website Details</h3>
        <txt label="Site Name" v-model="model.site_name"></txt>
        <div class="form-group">
            <label for="domain" class="control-label">
                Live Domain <small v-if="model.is_live">(Active)</small>
            </label>
            <input id="domain" name="domain" type="text" class="form-control" v-model="model.domain">
        </div>
        <div class="form-group">
            <label for="dev_domain" class="control-label">
                Dev Domain <small v-if="!model.is_live">(Active)</small>
            </label>
            <div class="input-group">
                <input type="text" class="form-control" id="dev_domain" v-model="model.dev_domain">
                <span class="input-group-addon">{{ demo_domain }}</span>
            </div>
        </div>

        <div class="buttons clearfix">
            <div class="pull-left">
                <button class="btn btn-default" type="button" @click="showModal">
                    Activate <span v-if="model.is_live">Dev</span><span v-if="!model.is_live">Live</span> Domain
                </button>

                <div class="btn-group" role="group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="icon icon-sign-in-1"></i> Admin Actions
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a @click="reMigrate">Re-Start Migration</a></li>
                        <li><a @click="dbMigrate">Re-Migrate DB</a></li>
                        <li><a @click="fixConfig">Fix Config</a></li>
                        <li><a @click="packup">Packup Website</a></li>
                    </ul>
                </div>
            </div>
            <div class="pull-right">
                <button class="btn btn-success" @click="store">
                    <i class="icon icon-save"></i> {{ trans('save') }}
                </button>
            </div>
        </div>

        <h3 class="form-heading">Additional Info</h3>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company name="Website" v-model="model.company"></company>
        </div>

        <div class="form-group">
            <label class="control-label">Server</label>
            <input readonly type="text" value="AWS ECS" class="form-control" />
        </div>

        <h3 class="form-heading">CMS Access <small>These details will not update if you manually change the password.</small></h3>

        <div class="split-fields">
            <txt label="Username" v-model="model.username"></txt>
            <txt label="CMS Password" v-model="model.password"></txt>
        </div>

        <a :href="model.admin_url" target="_blank" class="btn btn-primary">Log In</a>

        <div id="request_domain" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="panel-heading">
                            <h1>Active Domain Change Confirmation</h1>
                        </div>
                    </div>

                    <p>Before changing your active domain, it is important you follow the steps below.</p>

                    <h3>Activating a Live Domain</h3>
                    <p>Ensure you point your domain's name servers to:</p>
                    <ul style="list-style:none;">
                        <li>ns1.maek.it</li>
                        <li>ns2.maek.it</li>
                    </ul>
                    <p>Alternatively you can set the A record of your domain to:
                        <strong>202.60.67.27</strong></p>

                    <p>Also, it is important you modify your site's config files where appropriate to reflect your new domain.</p>

                    <h3>Activating a Dev Domain</h3>
                    <p>Since you're use our maekit.site domain in this instance, you won't need to worry about your nameservers. Just modify your site's config files where appropriate to reflect your new domain.</p>
                    <p>If you mess it up, don't worry, just switch your domain back.</p>
                    <br />
                    <!--<button class="btn btn-default" click="closeModal"><i class="icon icon-cancel"></i> {{ trans('cancel') }}</button>-->
                    <button type="button" class="btn btn-default" @click="toggleLive">Confirm Change</button>
                </div><!-- End of div modal-content -->
            </div><!-- End of div modal-dialog -->
        </div><!-- End of div qcModal -->
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        data() {
            return {
                wprProcessing: false,
                nonce: false,
                enablingSSL: false,
                enablingHttps: false,
                model: {
                    public_id: 0,
                    site_name: '',
                    wpr_id: 0,
                    company: '',
                    is_live: 0,
                    domain: '',
                    app_id: '',
                    server: '',
                    dev_domain: '',
                    username: '',
                    password: '',
                    cms_password: '',
                    admin_url: '',
                },
                demo_domain: '.myworkdemo.com.au',
                ftp_list: []
            }
        },
        created() {
            this.$eventHub.$on('websiteAction', this.doAction);
            this.$eventHub.$on('websiteSubmit', this.store);
            this.$eventHub.$on('setWebsite', this.setWebsite);
        },
        methods: {
            reMigrate() {
                this.axios.post('/api/website/action', {
                    doAction: 'reMigrate',
                    website_id: this.model.public_id
                }).then((response) => {
                    alert('Action Started');
                    fyi(response);
                }).catch((error) => {
                    let data = error.response.data;
                    alert('Error');
                    fyi(data);
                    resolve(data.error);
                });
            },
            dbMigrate() {
                Swal.fire({
                    title: 'WARNING: This action cannot be undone.',
                    text: 'format: "oldUser"',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#33C7A5',
                    cancelButtonColor: '#00ADD3',
                    confirmButtonText: 'Yes, I am sure',
                    input: 'text',
                    preConfirm: (text) => {
                        return new Promise((resolve, reject) => {
                            this.axios.post('/api/website/action', {
                                doAction: 'migrateDB',
                                website_id: this.model.public_id,
                                oldDetails: text
                            }).then((response) => {
                                alert('Success DB Migrated');
                                fyi(response);
                            }).catch((error) => {
                                let data = error.response.data;
                                alert('Error');
                                fyi(data);
                                resolve(data.error);
                            });
                            resolve('Wait for the alert....');
                        })
                    },
                    allowOutsideClick: false
                }).then(function (message) {
                    Swal.fire({
                        type: 'success',
                        title: 'Operation running:',
                        html: message
                    })
                });
            },
            fixConfig() {
                Swal.fire({
                    title: 'WARNING: This action cannot be undone.',
                    text: 'format: "oldUser"',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#33C7A5',
                    cancelButtonColor: '#00ADD3',
                    confirmButtonText: 'Yes, I am sure',
                    input: 'text',
                    preConfirm: (text) => {
                        return new Promise((resolve, reject) => {
                            this.axios.post('/api/website/action', {
                                doAction: 'fixConfig',
                                website_id: this.model.public_id,
                                oldDetails: text
                            }).then((response) => {
                                alert('Success DB Migrated');
                                fyi(response);
                            }).catch((error) => {
                                let data = error.response.data;
                                alert('Error');
                                fyi(data);
                                resolve(data.error);
                            });
                            resolve('Wait for the alert....');
                        })
                    },
                    allowOutsideClick: false
                }).then(function (message) {
                    Swal.fire({
                        type: 'success',
                        title: 'Operation running:',
                        html: message
                    })
                });
            },
            packup() {
                myAlert({ success: 'Packup initiated... Please wait for an update...' });
                this.axios.post('/api/website/action', {
                    doAction: 'packup',
                    website_id: this.model.public_id,
                }).then((response) => {
                    fyi(response);
                    myAlert({ success: response.data.success });
                }).catch((error) => {
                    let data = error.response.data;
                    alert('Error');
                    fyi(data);
                });
            },
            showModal() {
                $('#request_domain').modal('show');
            },
            hideModal() {
                $('#request_domain').modal('hide');
            },
            toggleLive() {
                this.$eventHub.$emit('websiteAction', 'setLive');
            },

            doAction(data) {
                let postData = {};
                if (typeof data === 'string') {
                    postData = {
                        doAction: data,
                        website_id: this.model.public_id,
                    };
                } else if (typeof data === 'object') {
                    postData = data;
                    postData.website_id = this.model.public_id;
                } else {
                    myAlert({ error: 'Bad Button. Please contact us.' });
                    return;
                }

                this.axios.post('/api/website/action', postData).then(function (response) {
                    if (typeof response.data !== 'undefined' && typeof response.data.success !== 'undefined') {
                        myAlert({success: response.data.success});
                    } else if (typeof response.data !== 'undefined' && typeof response.data.error !== 'undefined') {
                        myAlert(response.data.error);
                    } else {
                        myAlert({ success: 'Action initiated' })
                    }
                }).catch(() => {
                    myAlert('There was an error with that request.');
                });
            },

            store() {
                this.model.modal = false;
                this.model.loader = true;
                this.$store('/api/website/store', this);
            },
            setWebsite(data) {
                this.model = this.$setData(data, this.model);
                /*this.axios.get('/api/website/' + this.model.public_id + '/ftp-list').then((response) => {
                    let data = response.data;
                    this.ftp_list = data.ftp_list;
                }).catch((errors) => {
                    fyi(errors);
                });*/
            },
            href(link) {
                return '/website/' + this.model.public_id + link
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('websiteAction', this.doAction);
            this.$eventHub.$off('websiteSubmit', this.store);
            this.$eventHub.$off('setWebsite', this.setWebsite);
        }
    }
</script>
